




















import { Component, Prop, Vue, Emit } from 'vue-property-decorator';
import FileUpload from './FileUpload.vue';

@Component({
  name: 'Bytes',
  components: {
    FileUpload,
  },
})
export default class Bytes extends Vue {
  @Prop() public argument!: any;
  @Prop({ default: false }) public readonly disabled!: boolean;
  @Prop({ default: null }) public readonly defaultValue!: any;

  private uploadEnabled: boolean = false;


  get arg() {
    return this.defaultValue ? this.defaultValue : '0x';
  }

  set arg(value) {
    console.log('ArgumentHandler', { [this.argument.name.toString()]: value });
    this.selected(value);
  }

  @Emit('selected')
  public selected(value: any) {
    return { [this.argument.name.toString()]: value };
  }

  private enableUpload() {
    this.uploadEnabled = true;
  }
}
